import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useIonRouter } from "@ionic/react";
import { ROUTES } from "@shared/constants/routes";
import { workoutExecutionStore } from "@features/workout/execution/workoutExecutionStore";
import { useUserService } from "@entities/User";
import {
  getApproxWorkoutCalories,
  readWorkoutCompletionSnapshot,
} from "./lib/workoutCompletionSnapshot";
import { WorkoutCompletionScreen } from "./ui/WorkoutCompletionScreen";

export const WorkoutCompletionPage = () => {
  const { trainingID } = useParams<{ trainingID: string }>();
  const nav = useIonRouter();
  const userService = useUserService();
  const workoutHistoryID = Number(trainingID);
  const fallbackExercisesAmount = workoutExecutionStore.exercisesAmount || 1;
  const snapshot = useMemo(
    () =>
      Number.isFinite(workoutHistoryID) && workoutHistoryID > 0
        ? readWorkoutCompletionSnapshot(workoutHistoryID)
        : null,
    [workoutHistoryID],
  );

  const completionStats = snapshot ?? {
    calories: getApproxWorkoutCalories(1, userService?.data.weight),
    completedExercises: fallbackExercisesAmount,
    exercisesAmount: fallbackExercisesAmount,
    totalSeconds: 60,
    totalMinutes: 1,
  };

  return (
    <WorkoutCompletionScreen
      calories={completionStats.calories}
      completedExercises={completionStats.completedExercises}
      exercisesAmount={completionStats.exercisesAmount}
      totalSeconds={completionStats.totalSeconds}
      totalMinutes={completionStats.totalMinutes}
      onHome={() => nav.push(ROUTES.overall.main)}
    />
  );
};
